import { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface Props {
  icon: React.ReactNode;
  title: string;
  description: string;
  children: React.ReactNode;
}

export function ActionAccordionCard({ icon, title, description, children }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Card className='gap-3 py-0'>
      <CardHeader
        onClick={() => setIsOpen(!isOpen)}
        className='hover:bg-muted/50 flex cursor-pointer items-center gap-2 py-6'
      >
        <div className='space-y-1.5'>
          <div className='flex items-center gap-2'>
            <div className='flex items-center gap-2'>{icon}</div>
            <CardTitle>{title}</CardTitle>
          </div>
          <CardDescription>{description}</CardDescription>
        </div>
        <ChevronDownIcon className={cn('ml-auto size-4 transition-transform', isOpen && 'rotate-180')} />
      </CardHeader>
      {isOpen && <CardContent className='mt-0 pb-6'>{children}</CardContent>}
    </Card>
  );
}
